export const conversationalInboundMessageTriggers = "/:app_group_id/conversational/inbound_message_triggers";
